<template>
    <div>
        <b-container class="px-0">
            <card-layout
                title=""
                class="mb-0"
                :display-card="false"

            >
            
              <apexchart
                type="line"
                height="300"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </card-layout>
        </b-container>
    </div>
</template>

<script setup>
    import { onMounted, computed, ref} from 'vue';
    import { storeToRefs } from 'pinia';
    import CardLayout from '../details/CardLayout.vue'
    import styles from '../../../sass/_export.module.scss';


    // Stores
    import { useToplinesStore } from '../../stores/toplines';

    const toplinesStore = useToplinesStore();

    // Store refs
    const {
        toplineData,
    } = storeToRefs(toplinesStore);

    // Props
    const props = defineProps({
        name: {required: true, default: '', type: String},
        value: {required: true, default: '', type: String},
    });

    const series = computed(() => {
      if (props.value === 'control_sim_timeseries') {
        return [{
            name: 'Democrat',
            data: toplineData.value === null ? []: toplineData.value['historical'][props.value]
          }
        ]
      }
      else if (props.value === 'total_category_seats_timeseries') {
        // return [{
        //     name: 'Democrat',
        //     data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['dem'],
        //   },
        //   {
        //     name: 'Tossup',
        //     data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['tossup'],
        //   },
        //   // {
        //   //   name: 'Republican',
        //   //   data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['rep'],
        //   // }
        // ]
        return [{
            name: 'Democrat',
            data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['dem'].map((val, i) => (val + (toplineData.value['historical'][props.value]['tossup'][i]/2)).toFixed(0)),
          },
        ]
      }
      else if (props.value === 'total_pred_margin_seats_timeseries') {
        return [{
            name: 'Democrat',
            data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['dem']
          },
          // {
          //   name: 'Republican',
          //   data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['rep']
          // }
        ]
      }
      else if (props.value === 'total_win_prob_seats_timeseries') {
        return [{
            name: 'Democrat',
            data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['dem']
          },
          // {
          //   name: 'Republican',
          //   data: toplineData.value === null ? []: toplineData.value['historical'][props.value]['rep']
          // }
        ]
      }
      })

    // Chart options
    const chartOptions = computed(() => {
      console.log(props.name);
      if (props.value === 'control_sim_timeseries') {
        return {
          ...chartOptionsDefault.value,
          chart: {
            id: props.name + '-chart-id',
            toolbar: {
              show: false
            },
          },
          xaxis: {
            type: 'datetime',
            categories: toplineData.value === null ? []: toplineData.value['historical']['control_sim_dates']
          },
          yaxis: {
            title: {
              text: 'Percentage',
            },
            labels: {
              formatter: function (val) {
                return Math.round(val * 100) + "%";
              }
            },
          }
        }
      }
      else if (props.value === 'total_category_seats_timeseries') {
        return {
          ...chartOptionsDefault.value,
          colors: [styles.demColor1, styles.gray500, styles.repColor1],
          chart: {
            id: props.name + '-chart-id',
            toolbar: {
              show: false
            },
          },
          xaxis: {
            type: 'datetime',
            categories: toplineData.value === null ? []: toplineData.value['historical']['dates']
          },
          yaxis: [
            {
              title: {
                text: 'Total Seats',
              },
              labels: {
                formatter: function (val) {
                  return (val).toFixed(0);
                }
              }
            },
            // Add the Tossup scale on the right
            // {
            //   seriesName: 'Tossup',
            //   opposite: true,
            //   title: {
            //     text: 'Total Tossup Seats',
            //   },
            //   labels: {
            //     formatter: function (val) {
            //       return (val).toFixed(0);
            //     }
            //   }
            // },
        ]
        }
      }
      else {
        return {
          ...chartOptionsDefault.value,
          chart: {
            id: props.name + '-chart-id',
            toolbar: {
              show: false
            },
          },
          xaxis: {
            type: 'datetime',
            categories: toplineData.value === null ? []: toplineData.value['historical']['dates']
          },
          yaxis: {
            title: {
              text: 'Total Seats',
            },
            labels: {
              formatter: function (val) {
                return (val).toFixed(0);
              }
            }
          }
        }
        
      }

      return chartOptionsDefault.value;
    });
    
    const chartOptionsDefault = ref({
        chart: {
            height: 350,
            type: 'line',
            background: styles.bodyBg,
            dropShadow: {
                enabled: false,
            },
            toolbar: {
              show: false,
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
              }
            },
        },
        colors: [styles.demColor1, styles.repColor1],
        fill: {
            type:'solid',
        },
        grid: {
            borderColor: styles.gridBorder,
            row: {
                colors: [styles.gridLine, 'transparent'],
                opacity: 0.5
            },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'right',
            floating: false,
            fontSize: '12px',
            offsetY: 8,
            offsetX: -5,
        },
        markers: {
            size: [5, 5, 5, 0],
        },
        stroke: {
            width: 2.5,
            curve: 'smooth'
        },
        title: {
            text: '',
            align: 'left',
            style: {
                fontSize:  '12px',
                fontWeight:  'normal',
                },
        },
        tooltip: {
          // shared: false,
          // intersect: true,
          enabled: true,
          custom: customTooltipFormatter,
        },
        xaxis: {
            type: 'datetime',
            title: {
                text: 'Date'
            },
            labels: {
                datetimeFormatter: {
                    year: 'yyyy',
                    month: 'MMM \'yyyy',
                    day: 'dd MMM',
                    hour: 'HH:mm'
                }
            }
        },
        yaxis: {
            title: {
                text: 'Percentage'
            },
        },
        legend: {
          // showForSingleSeries: true,
          horizontalAlign: 'right'
        },
    });
    
  //Use apexcharts css classes pulled from the tooltip code to match default apexcharts styling
  //https://github.com/apexcharts/apexcharts.js/blob/main/src/modules/tooltip/Tooltip.js
  function customTooltipFormatter( {series, seriesIndex, dataPointIndex, w}) {

      let demVal;
      let repVal;

      if (props.value === 'control_sim_timeseries') {
        demVal = Math.round(series[0][dataPointIndex] * 100) + '%';
        repVal =  Math.round((1 - series[0][dataPointIndex]) * 100) + '%';
      }
      else {
        demVal = series[0][dataPointIndex];
        repVal = 435 - demVal;
      }

      const category = w.config.xaxis.categories[dataPointIndex];
      // Convert to Date and format as "day short month"
      const date = new Date(category);
      const formattedDate = date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC'  // Force UTC timezone
      });

      return `
      <div>
          <div class="apexcharts-tooltip-title" style="font-family: Lato, sans-serif; font-size: 12px;">${formattedDate}</div>
          <div class="apexcharts-tooltip-text mx-2" style="font-family: Lato, sans-serif; font-size: 12px;">
              <div class="apexcharts-tooltip-y-group d-flex">
                  <span class="apexcharts-tooltip-marker" style="background-color:${styles.demColor1}; border-radius: 50%; width: 12px; height: 12px;"></span>
                  <span class="apexcharts-tooltip-text-y-label me-1">Democrat: </span>
                  <span class="apexcharts-tooltip-text-y-value ms-auto">${demVal}</span>
              </div>
              <div class="apexcharts-tooltip-y-group d-flex">
                  <span class="apexcharts-tooltip-marker" style="background-color:${styles.repColor1}; border-radius: 50%; width: 12px; height: 12px;"></span>
                  <span class="apexcharts-tooltip-text-y-label me-1">Republican: </span>
                  <span class="apexcharts-tooltip-text-y-value ms-auto">${repVal}</span>
              </div>
          </div>
      </div>
      `;
      //REVISIT - Add marker above - Seeems to disappear when in a div so maybe some other CSS is getting activated. 
      // <span class="apexcharts-tooltip-marker ms-2" style="background-color: ${w.globals.colors[seriesIndex] };"></span>
  };

    onMounted(() => {
        console.log('TotalsHistoricalTimeline Component mounted.');
    });

</script>
<style>
</style>